import type { FaireProductEntity } from "../../entity_types/product";

export const p_atkpn5ns2e: FaireProductEntity = {
  token: "p_atkpn5ns2e",
  type: "product",
  name: "Water Fountain - Buddha",
  brandToken: "b_brgwq19hx1",
  brandName: "Earths Elements Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/80a73a89071d20587448252a7a48949e0df953bfab5d489db7a793931339dcfc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32d84e78617b1af3f5398d74ea8335334802283f3f1d0f55410e0374b010f1dd.jpeg",
    "https://cdn.faire.com/fastly/ddce49bfccf595cd225166711dc1a75d20baaada2a71e0b5c4039586a5b7bdc4.jpeg",
  ],
  priceDollars: 27.71,
  description:
    'WF-KYB\nWater Fountain - Buddha. 4 Tiered Fountain with crystal orb with lights and Buddha Statue. Comes with pump with USB Connector included.\n12"H x 8"W\nMin. 1\n\nThis captivating fountain features an exquisitely detailed Buddha statue, meticulously crafted to capture the tranquil expression and meditative posture that symbolize inner calm and spiritual enlightenment. The Buddha is seated in a serene pose, with water flowing gently around the figure, creating a mesmerizing and soothing visual display.\nCrafted with meticulous detail, this water fountain not only brings tranquility to your environment but also serves as a stunning decorative piece. Ideal for indoor spaces, it adds a touch of spiritual elegance to your home or office.\n\nElevate your metaphysical store\'s inventory with our premium products, now available at competitive wholesale rates.',
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:13.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
